<template>
  <v-card outlined class="pa-3">
    <div class="overline text-center">
      Reccomended exchange rate:
    </div>
    <div class="pa-2">
      <span class="overline">
        {{ primaryCurrency.symbol }} / {{ defaultCurrency.symbol }}
      </span>
      =
      <span class="">
        <span v-if="rateIsApproximate">~</span>
        {{ rate }}
      </span>
    </div>

    <div class="text-right caption textSecondary--text">
      Last updated {{ firstDate }}
    </div>

    <v-row class="justify-end">
      <v-btn small depressed color="primary" dark @click="updateRate">
        Use
      </v-btn>
    </v-row>
  </v-card>
</template>

<script>
export default {
  props: {
    currency: null,
    baseCurrency: { // if not specified it defaults to your stored base currency
      type: Number,
      default: null
    }
  },
  computed: {
    defaultCurrency () {
      if (this.baseCurrency) {
        return this.$store.state.db.currencies.items[this.baseCurrency]
      } else {
        return this.$store.state.db.currencies.items[this.$store.state.settings.currency]
      }
    },
    primaryCurrency () {
      return this.$store.state.db.currencies.items[this.currency] || {}
    },
    conversionNecessary () {
      if (this.currency !== this.defaultCurrency.id) {
        return true
      }
      return false
    },
    userDefinedRate () {
      return Object.values(this.$store.state.db.currencyRates.items).find(item => item.currency_1 === this.currency && item.currency_2 === this.defaultCurrency.id )
    },
    rateIsApproximate () {
      if (!this.conversionNecessary || this.userDefinedRate) {
        return false
      }
      return true
    },
    rate () {
      if (this.conversionNecessary) {
        var match = Object.values(this.$store.state.db.currencyRates.items).find(item => item.currency_1 === this.currency && item.currency_2 === this.defaultCurrency.id )
        if (this.userDefinedRate) {
          return this.userDefinedRate.rate
        }
        // ok no matches, try to build your own approximation
        // return currency.rate * this.defaultCurrency.rate
        return this.defaultCurrency.rate / this.primaryCurrency.rate
      } else {
        return 1
      }
    },
    firstDate () {
      var first_date = this.$moment.min(this.$moment(this.defaultCurrency.last_updated), this.$moment(this.primaryCurrency.last_updated))
      if (this.$moment.utc(first_date).isValid()) {
        return this.$moment.utc(first_date).fromNow()
      }
      return ''
    }
  },
  watch: {
    rate (nv) {
      this.automaticRateUpdate()
    }
  },
  methods: {
    automaticRateUpdate () {
      var rate = {
        rate: this.rate,
        rateIsApproximate: this.rateIsApproximate
      }
      this.$emit('updateRateAutomatic', rate)
    },
    updateRate () {
      var rate = {
        rate: this.rate,
        rateIsApproximate: this.rateIsApproximate
      }
      this.$emit('updateRate', rate)
    },
  }
}
</script>